/** How aggressively {@link normalizeText} normalizes input. Each level includes everything in the levels above it. */
export enum TextFoldLevel {
    /** Width, whitespace, Latin diacritics, and casing. */
    WHITESPACE_AND_CASING = "WHITESPACE_AND_CASING",
    /** {@link TextFoldLevel.WHITESPACE_AND_CASING} plus removal of separators and punctuation. */
    SEPARATORS_WHITESPACE_PUNCTUATION_AND_CASING = "SEPARATORS_WHITESPACE_PUNCTUATION_AND_CASING",
}

/**
 * Normalizes text for comparison. NFKC (not NFKD) so width folds without decomposing the combining
 * marks Gurmukhi and kana spell words with; only marks on a Latin base letter are stripped.
 */
export function normalizeText(raw: string, level: TextFoldLevel): string {
    const folded = raw
        .normalize("NFKC")
        .replace(/\s+/gu, " ")
        .trim()
        .normalize("NFD")
        .replace(/(\p{Script=Latin})\p{Mn}+/gu, "$1")
        .normalize("NFC")
        .toLowerCase();
    if (level === TextFoldLevel.SEPARATORS_WHITESPACE_PUNCTUATION_AND_CASING) {
        return folded.replace(/[^\p{L}\p{N}\p{M}]/gu, "");
    }
    return folded;
}
